export default "__VITE_ASSET__C21d5xri__"